import { render, staticRenderFns } from "./support_ticket_details.vue?vue&type=template&id=42b5c4ee&"
import script from "./support_ticket_details.vue?vue&type=script&lang=js&"
export * from "./support_ticket_details.vue?vue&type=script&lang=js&"
import style0 from "./support_ticket_details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports